<template>
	<div id="home">
		<HomeNavComponet/>
		<HomeComponent/>
		<HomeTailComponent/>
	</div>
</template>

<script>
import HomeNavComponet from '@/components/common/HomeNavComponet.vue'
import HomeComponent from '@/components/home/HomeComponent.vue';
import HomeTailComponent from '@/components/common/HomeTailComponent.vue';

// import axios from 'axios'

export default {
  name: 'HomeView',
	components: {
		HomeNavComponet,
		HomeComponent,
		HomeTailComponent
	}
}
</script>

<style scoped>
.router-link-active{
  padding-left: 0;
}
</style>

